import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CheckboxControlValueAccessor } from '@angular/forms';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  baseUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}
  // Guarda las configuraciones del usuario
  postUsuariosNotificaciones(celular: string) {
    return this.http
      .post<any>(this.baseUrl + '/usuario/', {
        _celular: celular
      })
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && user.username) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
          }

          return user;
        })
      );
  }

  getCurrentUserInfo() {
    return this.http.get<any>(this.baseUrl + '/usuarios').pipe(
      map(user => {
        return user;
      })
    );
  }

  registrar(user: Object) {
    return this.http.post(this.baseUrl + '/usuarios', user);
  }

  editarUsuario(user: Object) {
    return this.http.put(this.baseUrl + '/editar-usuarios', user);
  }

  getUsuarioSuscripciones() {
    return this.http.get(this.baseUrl + '/usuarios-suscripciones');
  }

  deleteUsuarioSuscripcion(id) {
    return this.http.delete(this.baseUrl + '/usuarios-suscripciones/' + id);
  }
}
